import React, { useState, useEffect } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'
import { RawExpando } from 'discada/dist/Expando'
import { ABE_CHAT_ROOFTOPS } from 'utils'

import SalesLeadForm from 'components/forms/SalesLeadForm'

import { getIsLoggedIn, getIsDealerBrowser } from 'selectors/authSelectors'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { updateAbeChatPosition, untagCustomer } from 'actions/appStatusActions'

import { useInterval } from 'utils/hooks'

import {
  addToPageState,
  pushRooftopRoute,
  removeFromPageState,
} from 'actions/pageStateActions'

import {
  getRooftopId,
  getTaggedCustomerFromState,
  isSqueezeJacketOpen,
} from 'selectors/appStatusSelectors'

import { ConnectedLeadStory as LeadStory } from 'components/Lead/LeadStory'

import { getLeadDetails } from 'actions/leadActions'

import abe from 'static/images/abe/abe.png'
import abeXray from 'static/images/abe/abe-xray.png'
import abeMoney from 'static/images/abe/abe-money.png'

import './AbeChat.scss'
import 'components/Quote/Reactions.scss'
import { getEntity } from 'selectors/entitySelectors'
import isEmpty from 'lodash/isEmpty'
import { POLL_INTERVAL } from 'components/Lead'

export const CONTENT_KEYS = {
  leadDetails: 'leadDetails',
  squeezeJacket: 'squeezeJacket',
  customizeDemo: 'customizeDemo',
}

export function AbeChat(props) {
  let {
      className,
      abeOk,
      dblExists,
      sessionId,
      getLeadDetails,
      squeezeJacketIsOpen,
      delay = 0, //millis
    } = props,
    [open, setOpen] = useState(props.open),
    [openOk, setOpenOk] = useState(),
    [showLeadForm, setShowLeadForm] = useState(),
    [contentKey, setContentKey] = useState(CONTENT_KEYS.leadDetails),
    toggle = () => setOpen(!open),
    Content

  useEffect(() => openOk && setOpen(true), [openOk])

  useInterval(
    () => abeOk && getLeadDetails(sessionId, { withPins: false }),
    POLL_INTERVAL,
  )

  // when jacket open and not show lead form: SqueezeJacketContent
  if (!dblExists || squeezeJacketIsOpen)
    Content = CONTENT[CONTENT_KEYS.squeezeJacket]
  // when jacket closed and not show lead form: LeadDetails
  else Content = CONTENT[CONTENT_KEYS.leadDetails]

  // when show lead form: SaledLeadForm
  if (showLeadForm) Content = CONTENT[CONTENT_KEYS.customizeDemo]

  if (!abeOk) return null

  window.setTimeout(() => setOpenOk(true), delay)

  return (
    <RawExpando open={open}>
      {() => {
        return (
          <div className={c('abe-chat', className, contentKey)}>
            {open && Content && (
              <div className="abe-chat-inner">
                <Content
                  {...props}
                  toggle={toggle}
                  showLeadForm={showLeadForm}
                  setShowLeadForm={setShowLeadForm}
                  setContentKey={setContentKey}
                />
              </div>
            )}
            <div className="abe-head" onClick={toggle}>
              {!open && <Icon icon="hand-pointer" />}
              <img src={ABE[contentKey]} className="logo" alt="Abe says..." />
            </div>
          </div>
        )
      }}
    </RawExpando>
  )
}

function mapStateToProps(state, op) {
  let dealerId = getRooftopId(state),
    isSalesRooftop = ABE_CHAT_ROOFTOPS.includes(dealerId),
    existingLead = getTaggedCustomerFromState(state),
    name = get(existingLead, 'firstName'),
    forceAbe = getQueryValue(state, 'forceAbe'),
    sessionId = get(getTaggedCustomerFromState(state), 'sessionId'),
    lead = getEntity(state, sessionId),
    leadExists = !isEmpty(lead),
    dblExists = !isEmpty(get(lead, 'stories', []))

  return {
    ...op,
    name,
    leadExists,
    dblExists,
    existingLead,
    sessionId,
    squeezeJacketIsOpen: isSqueezeJacketOpen(state),
    engagementScore: get(lead, 'summary.engagementScore'),
    abeOk:
      forceAbe ||
      (isSalesRooftop && !getIsLoggedIn(state) && !getIsDealerBrowser(state)),
  }
}

export default connect(
  mapStateToProps,
  {
    pushRooftopRoute,
    addToPageState,
    removeFromPageState,
    getLeadDetails,
    untagCustomer,
  },
)(AbeChat)

/////////////////////

const BuyButton = ({ setShowLeadForm = () => {} }) => (
  <Button
    rounded
    size="small"
    className={c('reaction-button', 'buyNow')}
    onClick={() => setShowLeadForm(true)}
  >
    <span className="reaction-content">
      <span className="emoji" role="img" aria-label="created">
        🤩
      </span>{' '}
      <strong>Schedule a Frikin DEMO!</strong>
    </span>
  </Button>
)

const LeadDetails = ({ sessionId, setShowLeadForm, untagCustomer, toggle }) => (
    <div className="explainer-inner">
      <h4>Imagine getting insight like this...</h4>
      <div className="lead-details-dbl">
        <LeadStory id={sessionId} showTooltips={false} />
      </div>
      <h4 style={{ textAlign: 'right' }}>...right inside your CRM!</h4>
      <p>
        <BuyButton setShowLeadForm={setShowLeadForm} />
        <Button text size="small" onClick={toggle}>
          Close
        </Button>
        <Button text size="small" onClick={untagCustomer}>
          Reset
        </Button>
      </p>
    </div>
  ),
  SqueezeJacketExplainer = props => (
    <div className="explainer-inner">
      <h4>"What's in it for me?"</h4>
      <div className="lead-details-dbl">
        <span className="squeeze-jacket-copy">
          While your customers hone their payments by entering their{' '}
          <strong>Location</strong> (Taxes & Registration Fees),{' '}
          <strong>Trade</strong> (Equity), <strong>Incentives</strong> (Rebates
          & any dealer cash you want to pass on) and <strong>Credit</strong>{' '}
          (Lender Programs), you're discovering what motivates them. Play with a
          few cars to see how that works.
        </span>
      </div>
      <p>
        <BuyButton {...props} />
        <Button text size="small" onClick={props.toggle}>
          Close
        </Button>
        <Button text size="small" onClick={untagCustomer}>
          Reset
        </Button>
      </p>
    </div>
  )

const CONTENT = {
  [CONTENT_KEYS.squeezeJacket]: SqueezeJacketExplainer,
  [CONTENT_KEYS.leadDetails]: LeadDetails,
  [CONTENT_KEYS.customizeDemo]: SalesLeadForm,
}

const ABE = {
  [CONTENT_KEYS.leadDetails]: abeXray,
  [CONTENT_KEYS.squeezeJacket]: abeMoney,
  [CONTENT_KEYS.customizeDemo]: abe,
}
